__turbopack_context__.v({
  "reviewsLink": "work-rating-module-scss-module__L4TtAG__reviewsLink",
  "root": "work-rating-module-scss-module__L4TtAG__root",
  "star": "work-rating-module-scss-module__L4TtAG__star",
  "starIcon": "work-rating-module-scss-module__L4TtAG__starIcon",
  "stars": "work-rating-module-scss-module__L4TtAG__stars",
  "u-animation-bounce": "work-rating-module-scss-module__L4TtAG__u-animation-bounce",
});
